export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Nombre comercial',
                    type: 'custom-html',
                    key: 'organization_initial',
                    modifier: (item) => {
                        return item ? (item.name).toUpperCase() : '';
                    }
                },
                {
                    title: 'Razón social',
                    type: 'custom-html',
                    key: 'organization_initial',
                    modifier: (item) => {
                        return (item?.business_name)?.toUpperCase();
                    }
                },
                {
                    title: 'Área',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (item) => {
                        return item?.accreditation_area?.name;
                    }
                },
                {
                    title: 'Áctividad',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (item) => {
                        return item?.accreditation_activity?.name;
                    }
                },
                {
                    title: 'Codigo de acreditación',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (item) => {
                        return item?.acc_number;
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'scope',
                    modifier: (item) => {
                        return "Acreditado";
                    }
                },
                {
                    title: 'Ciudad',
                    type: 'custom-html',
                    key: 'organization_initial',
                    modifier: (item) => {
                        if(item?.canton){
                            return item?.canton?.name;
                        }else{
                            return item?.city;
                        }
                        
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}